<div class="editForm">
  @switch (typeOf) {
    @case ('cta') {
      <edit-c-cta
        [cta]="typeOf"
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
        [defaultColors]="colors"
        [starterTheme]="starterTheme"
      ></edit-c-cta>
    }
    @case ('embed') {
      <edit-c-embed
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
      ></edit-c-embed>
    }
    @case ('feedback') {
      <edit-c-feedback
        [feed]="typeOf"
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
      ></edit-c-feedback>
    }
    @case ('image') {
      <edit-c-image
        [image]="typeOf"
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
        [defaultColors]="colors"
        [starterTheme]="starterTheme"
      ></edit-c-image>
    }
    @case ('showcase') {
      <ag-edit-c-showcase
        [isPopularList]="false"
        class="show"
        [show]="typeOf"
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
        [dynamic]="dynamic"
        [defaultColors]="colors"
        [starterTheme]="starterTheme"
        [widgetEdit]="widgetEdit"
      ></ag-edit-c-showcase>
    }
    @case ('showcase-list') {
      <ag-edit-c-showcase
        [isPopularList]="false"
        class="show"
        [show]="typeOf"
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
        [dynamic]="dynamic"
        [starterTheme]="starterTheme"
        [defaultColors]="colors"
      ></ag-edit-c-showcase>
    }
    @case ('popular-list') {
      <ag-edit-c-showcase
        [isPopularList]="true"
        class="show"
        [show]="typeOf"
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
        [dynamic]="dynamic"
        [defaultColors]="colors"
        [starterTheme]="starterTheme"
      ></ag-edit-c-showcase>
    }
    @case ('text') {
      <edit-c-text
        [textBlock]="typeOf"
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
      ></edit-c-text>
    }
    @case ('topic') {
      <edit-c-topic
        class="topic"
        [topic]="typeOf"
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
      ></edit-c-topic>
    }
    @case ('customerCare') {
      <edit-customer-care
        class="topic"
        [typeOf]="typeOf"
        [rowType]="rowType"
        [rowArray]="rowArray"
        [compArray]="compArray"
        [template]="template"
        [edit]="edit"
      ></edit-customer-care>
    }
    @default {
      <div class="empty-component">
        <i class="fa fa-ban" aria-hidden="true"></i>
        <div>Were sorry there seems a different option than what you have chosen.</div>
        <input
          class="form-control"
          [(ngModel)]="empty"
          placeholder="Send us a message"
          title="Send us a message"
        />
        <button
          role="button"
          type="button"
          aria-label="Send Message"
          class="btn btn-outline-primary"
          [disabled]="!empty"
        >
          Go
        </button>
      </div>
    }
  }
</div>
